export const ROLE_LABELS = {
  super_admin: "Super Administrator", admin: "Administrator / Director", teacher: "Teacher", staff: "Staff",
  billing_manager: "Billing Manager", payroll_manager: "Payroll Manager", parent: "Parent / Guardian",
  auditor: "Read-Only Auditor",
};
export const INTERNAL_ROLES = ["super_admin", "admin", "teacher", "staff", "billing_manager", "payroll_manager", "auditor"];
export const ADMIN_ROLES = ["super_admin", "admin"];
export const STAFF_ROLES = ["super_admin", "admin", "teacher", "staff"];
export const FINANCE_ROLES = ["super_admin", "admin", "billing_manager"];
export const PAYROLL_ROLES = ["super_admin", "admin", "payroll_manager"];

export const isAdmin = (u) => ADMIN_ROLES.includes(u?.role);
export const isSuper = (u) => u?.role === "super_admin";
export const isStaff = (u) => STAFF_ROLES.includes(u?.role);
export const isParent = (u) => u?.role === "parent";
export const isInternal = (u) => INTERNAL_ROLES.includes(u?.role);
export const canFinance = (u) => FINANCE_ROLES.includes(u?.role);
export const canPayroll = (u) => PAYROLL_ROLES.includes(u?.role);
export const can = (u, resource, action = "view") =>
  isSuper(u) || Boolean(u?.permissions?.[resource]?.includes(action));
export const homeFor = (role) => (role === "parent" ? "/portal" : "/admin");
